
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#92B8B8","stroke-width":"1.12","d":"M6.685 1.216a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Zm0 4.807a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Zm0 4.908a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Zm0 4.853a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Zm4.76-14.568a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Zm0 4.807a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Zm0 4.908a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Zm0 4.853a.565.565 0 1 1-1.13 0 .565.565 0 0 1 1.13 0Z"}})])
          )
        }
      }
    